/* eslint-disable react-hooks/exhaustive-deps */

import React, { useContext, useEffect } from "react";
import { TableRow, TableCell, Paper } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  IconButtonDatatable,
  Loading,
  DatatablesFooterServerSide,
  SearchInput,
} from "App/Component/ui";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import { headCells } from "./helpers";
import { SelectIcon } from "App/Assets";
import { formatNumber, isNull } from "App/utils/helpers";
import { FormContext } from "../../../context/FormContext";
import { FreezeTable } from "components/organism";
import { useDebounce } from "hooks";

export default function DaftarFasilitas({
  rows,
  handleClickSelect,
  setFormFilterFasilitasByKelas,
  formFilterFasilitasByKelas,
  totalData,
  setNewDataFasilitasByKelas,
  loading,
}) {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "namaMsFasilitas",
    orderByRow: ["namaMsFasilitas"],
  });

  const { formData } = useContext(FormContext);

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewDataFasilitasByKelas });

  const debounceSearchInput = useDebounce(formFilterFasilitasByKelas.name, 300);

  const handleSearchInput = () => {
    if (!isNull(formFilterFasilitasByKelas.name)) {
      setNewDataFasilitasByKelas(
        formFilterFasilitasByKelas.pages,
        formFilterFasilitasByKelas.limit,
        {
          name: formFilterFasilitasByKelas.name,
        }
      );
    } else {
      setNewDataFasilitasByKelas(
        formFilterFasilitasByKelas.pages,
        formFilterFasilitasByKelas.limit,
        {
          name: null,
        }
      );
    }
  };

  useEffect(() => {
    handleSearchInput();
  }, [debounceSearchInput]);

  return (
    <>
      <Paper
        style={{
          padding: "1rem",
        }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <p className='fw-600 fs-14'>Daftar Fasilitas</p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}>
            <div>
              <SearchInput
                withIcon={true}
                heightInput='0.4'
                onchange={(e) => {
                  setFormFilterFasilitasByKelas((prev) => {
                    return {
                      ...prev,
                      name: e.target.value,
                    };
                  });
                }}
              />
            </div>
          </div>
        </div>
        <Loading show={loading} />
        <div className='mt-1'>
          <FreezeTable
            headCells={headCells}
            handleRequestSort={handleRequestSort}
            order={order}
            length={length}
            maxHeight='400px'
            orderBy={orderBy}>
            {stableSort(rows, getComparator(order, orderBy)).map(
              (row, index) => {
                return (
                  <TableRow hover key={index}>
                    <TableCell
                      scope='row'
                      padding='none'
                      width='5%'
                      align='center'>
                      {index + 1}
                    </TableCell>

                    <TableCell
                      scope='row'
                      width='10%'
                      padding='none'
                      align='center'>
                      {!formData.is_lock && !formData.is_close && (
                        <IconButtonDatatable
                          color='secondary'
                          aria-label='delete'
                          onClick={() => handleClickSelect(row)}
                          style={{
                            background: "#D8D8D8",
                            padding: "5px 4px",
                          }}>
                          <SelectIcon
                            width={"14"}
                            height={"14"}
                            fill={"#fff"}
                          />
                        </IconButtonDatatable>
                      )}
                    </TableCell>
                    <TableCell align='left' width='5%'>
                      {row?.id_fasilitas}
                    </TableCell>
                    <TableCell align='left'>{row?.namaMsFasilitas}</TableCell>
                    <TableCell align='right' width='10%'>
                      {formatNumber(row?.harga_jual)}
                    </TableCell>
                    <TableCell align='left' width={"30%"}>
                      {row?.namaJsFasilitas}
                    </TableCell>
                  </TableRow>
                );
              }
            )}
            {rows.length === 0 && (
              <TableRow>
                <TableCell align='center' colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </FreezeTable>
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </div>
      </Paper>
      {/* <TableWrapper
        title='Fasilitas yang dijual'
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  width='5%'
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  component='th'
                  scope='row'
                  width='10%'
                  padding='none'
                  align='center'>
                  {!formData.is_lock && !formData.is_close && (
                    <IconButtonDatatable
                      color='secondary'
                      aria-label='delete'
                      onClick={() => handleClickSelect(row)}
                      style={{
                        background: "#D8D8D8",
                        padding: "5px 4px",
                      }}>
                      <SelectIcon width={"14"} height={"14"} fill={"#fff"} />
                    </IconButtonDatatable>
                  )}
                </TableCell>
                <TableCell align='left' width='5%'>
                  {row?.id_fasilitas}
                </TableCell>
                <TableCell align='left'>{row?.namaMsFasilitas}</TableCell>
                <TableCell align='right' width='10%'>
                  {formatNumber(row?.harga_jual)}
                </TableCell>
                <TableCell align='left' width={"30%"}>
                  {row?.namaJsFasilitas}
                </TableCell>
              </TableRow>
            );
          })}
      </TableWrapper> */}
    </>
  );
}
